export const ShopActionTypes = {
  RETRIEVE_PRODUCTS_DATA: 'RETRIEVE_PRODUCTS_DATA',
  RETRIEVE_PLANS_DATA: 'RETRIEVE_PLANS_DATA',
};
